import { useLocation } from "react-router-dom";

const SECTION_LABELS = {
  "/panel": "Overview",
  "/panel/cars": "My Cars",
  "/panel/profile": "Profile",
};

export default function Header({ onToggleSidebar }) {
  const { pathname } = useLocation();
  const currentLabel = SECTION_LABELS[pathname] || "Overview";

  return (
    <header className="dash-header">
      <button
        type="button"
        className="hamburger-btn"
        id="hamburgerBtn"
        aria-label="Open menu"
        onClick={onToggleSidebar}
      >
        <span />
        <span />
        <span />
      </button>
      <div className="breadcrumb">
        Fleet Owner · <strong id="breadcrumbCurrent">{currentLabel}</strong>
      </div>

      <div className="header-actions">
        <button type="button" className="icon-btn" aria-label="Notifications">
          🔔
          <span className="notif-dot" />
        </button>
        <div className="header-user">
          <span className="user-chip-avatar">👤</span>
          <div className="user-chip-info">
            <span className="user-chip-name" id="ownerName">
              Fleet Owner
            </span>
            <span className="user-chip-role">Fleet Owner</span>
          </div>
        </div>
      </div>
    </header>
  );
}
